<template>
  <v-form class="py-4 layout align-end">
    <v-flex v-if="filters.includes('hotspot')" lg4 xl2 md4 mr-3>
      <label>Адрес</label>
      <v-select
        v-model="params.id"
        @change="send"
        :items="$store.getters.hotspotList"
        item-value="id"
        item-text="address"
        height="34"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      >
        <template v-slot:selection="{ item }">
          <div class="ellipsis text-capitalize">
            {{ item.address ? item.address : item.title }}
          </div>
        </template>
        <template v-slot:item="{ item }">
          <div class="ellipsis text-capitalize">
            {{ item.address ? item.address : item.title }}
          </div>
        </template>
      </v-select>
    </v-flex>
    <div v-if="filters.includes('range')" class="flex mr-3 lg2 md4">
      <label>Период</label>
      <date-range-picker
        :range="params.range"
        :index="-1"
        :isShowError="true"
        @update="changeDate($event)"
      ></date-range-picker>
    </div>
    <v-flex v-if="filters.includes('country')" xl1 lg1 md4 mr-3>
      <label>Страна клиента</label>
      <v-select
        v-model="params.area"
        @change="send"
        :items="countries"
        item-value="value"
        item-text="title"
        height="34"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      >
        <template v-slot:selection="{ item }">
          <div class="ellipsis">{{ item.title }}</div>
        </template>
      </v-select>
    </v-flex>
    <v-btn @click="send" :loading="loading" class="primary mb-0">
      Показать
    </v-btn>
  </v-form>
</template>

<script>
import DateRangePicker from "../common/DateRangePicker.vue";
import moment from "moment";
export default {
  name: "DetailingFilter",

  components: {
    DateRangePicker,
  },

  props: {
    // активные фильтры
    filters: {
      type: Array,
      default: () => ["hotspot", "range"],
    },
    // параметры фильтров по умолчанию
    defaultParams: Object,
    // статус загрузки
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    // параметры формы
    params: {},
    // список стран
    countries: [
      {
        title: "все",
        value: null,
      },
      {
        title: "Россия",
        value: "russia",
      },
      {
        title: "Зарубеж",
        value: "foreing",
      },
    ],
    // для отображения IconClose
    isSeen: false,
  }),

  beforeMount() {
    // устанавливаем параметры по умолчанию
    this.params = { ...this.defaultParams };
  },

  methods: {
    /**
     * Отправляет выбранный период
     */
    send() {
      const params = {
        ...this.params,
        clientId: this.$store.getters.getHotspot(this.params.id).ess_client_id,
        serviceId: this.$store.getters.getHotspot(this.params.id).cl_service_id,
        range: {
          startDate: this.params.range.startDate,
          endDate: this.params.range.endDate,
        },
      };
      this.isSeen = true;
      this.$emit("filter", params);
    },
    // обновляем дату и отправляем данные
    changeDate(range) {
      this.params.range = range;
      if (!range.startDate) {
        this.params.range.startDate = moment().subtract(1, "month");
        this.params.range.endDate = new Date();
      }
      this.send();
      this.isSeen = false;
    },
  },
};
</script>
